/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { GeneralRow } from './AppNavRow';
import IconClose from '../../icons/IconClose';

const AppNavTextInput = props => {
  const classStyle = classnames('cmp-appnavtextinput', {
    'has-underline': props.isEditable,
  });

  return (
    <GeneralRow>
      <div className={classStyle} onClick={props.isEditable ? props.onClick : null}>
        <div className="cmp-appnavtextinput-icon">
          {props.icon}
        </div>

        {
          !props.value && (
            <div className="cmp-appnavtextinput-placeholder">
              {props.placeholder}
            </div>
          )
        }

        {
          props.value && <input
            value={props.value}
            onChange={props.onChange}
            onFocus={props.onFocus}
            onBlur={props.onBlur}
            readOnly
          />
        }

        {
          (props.value && props.isEditable) && (
            <div className="cmp-appnavtextinput-clear" onClick={(e) => { e.stopPropagation(); props.onClear(); }}>
              <IconClose.Small color="gsLightLT" />
            </div>
          )
        }
      </div>
    </GeneralRow>
  );
};
AppNavTextInput.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onClear: PropTypes.func,
  onClick: PropTypes.func,
  placeholder: PropTypes.string,
  icon: PropTypes.element,
  isEditable: PropTypes.bool,
};

export default AppNavTextInput;
